import React from 'react';

import Seo from 'src/uglib_components/seo'
import SidebarLayout from 'src/uglib_components/sidebarLayout'
import Sidebar from 'src/uglib_components/sidebar';
import SidebarMenu from 'src/uglib_components/sidebarMenu';
import StaffDirectory from 'src/uglib_components/staffDirectory';

const StaffDirectoryPage = ({ data, location }) => {

    const breadcrumbs = [
		{ 
			url: "",
			title: "About",
		},
	]

    let sidebar = <>
        <Sidebar>
            <SidebarMenu url={location.pathname}/>
        </Sidebar>
    </>;

    const title = "Staff Directory";

    return (
        <SidebarLayout title={title} sidebar={sidebar} breadcrumbs={breadcrumbs} applyStyles={true}>
            <Seo title={title} keywords={[]} />

            <p>
                General library inquiries? <a href="/contact-us/">Get in touch</a>.<br />
                Looking for someone specific? See our staff list below.
            </p>

            <StaffDirectory />
                        
        </SidebarLayout>
    )
}

export default StaffDirectoryPage
